'use client';

import React, { useEffect, useState } from 'react';

const CopyNotification: React.FC = () => {
  const [show, setShow] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleCopy = (e: ClipboardEvent) => {
      const selection = window.getSelection();
      if (selection && selection.toString().trim().length > 0) {
        // Get mouse position or use center of viewport
        const x = (e as any).clientX || window.innerWidth / 2;
        const y = (e as any).clientY || window.innerHeight / 2;
        
        setPosition({ x, y });
        setShow(true);

        // Hide after animation
        setTimeout(() => {
          setShow(false);
        }, 2500);
      }
    };

    document.addEventListener('copy', handleCopy);

    return () => {
      document.removeEventListener('copy', handleCopy);
    };
  }, []);

  if (!show) return null;

  return (
    <div data-component-id="src/components/CopyNotification.tsx:37:4" data-component-path="src/components/CopyNotification.tsx" data-component-line="37" data-component-end-line="66" data-component-file="CopyNotification.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22fixed%20pointer-events-none%20z-%5B9999%5D%22%7D"
      className="fixed pointer-events-none z-[9999]"
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
        transform: 'translate(-50%, -50%)',
      }}
    >
      <div data-component-id="src/components/CopyNotification.tsx:45:6" data-component-path="src/components/CopyNotification.tsx" data-component-line="45" data-component-end-line="65" data-component-file="CopyNotification.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%22%7D" className="relative">
        {/* Animated emoji */}
        <div data-component-id="src/components/CopyNotification.tsx:47:8" data-component-path="src/components/CopyNotification.tsx" data-component-line="47" data-component-end-line="49" data-component-file="CopyNotification.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20-top-12%20left-1%2F2%20-translate-x-1%2F2%20text-4xl%20animate-bounce%22%2C%22textContent%22%3A%22%F0%9F%A4%94%22%7D" className="absolute -top-12 left-1/2 -translate-x-1/2 text-4xl animate-bounce">
          🤔
        </div>
        
        {/* Message box */}
        <div data-component-id="src/components/CopyNotification.tsx:52:8" data-component-path="src/components/CopyNotification.tsx" data-component-line="52" data-component-end-line="56" data-component-file="CopyNotification.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22glass-card%20px-6%20py-3%20rounded-2xl%20shadow-2xl%20animate-scale-in%20border-2%20border-primary%2F30%22%7D" className="glass-card px-6 py-3 rounded-2xl shadow-2xl animate-scale-in border-2 border-primary/30">
          <p data-component-id="src/components/CopyNotification.tsx:53:10" data-component-path="src/components/CopyNotification.tsx" data-component-line="53" data-component-end-line="55" data-component-file="CopyNotification.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-lg%20font-semibold%20text-primary%20whitespace-nowrap%22%2C%22textContent%22%3A%22Why%20do%20you%20want%20to%20copy%20this%3F%22%7D" className="text-lg font-semibold text-primary whitespace-nowrap">
            Why do you want to copy this?
          </p>
        </div>

        {/* Sparkle effects */}
        <div data-component-id="src/components/CopyNotification.tsx:59:8" data-component-path="src/components/CopyNotification.tsx" data-component-line="59" data-component-end-line="60" data-component-file="CopyNotification.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20-top-4%20-left-4%20w-3%20h-3%20bg-primary%2F60%20rounded-full%20animate-ping%22%7D" className="absolute -top-4 -left-4 w-3 h-3 bg-primary/60 rounded-full animate-ping" 
             style={{ animationDelay: '0.1s' }} />
        <div data-component-id="src/components/CopyNotification.tsx:61:8" data-component-path="src/components/CopyNotification.tsx" data-component-line="61" data-component-end-line="62" data-component-file="CopyNotification.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20-top-2%20-right-4%20w-2%20h-2%20bg-accent%2F60%20rounded-full%20animate-ping%22%7D" className="absolute -top-2 -right-4 w-2 h-2 bg-accent/60 rounded-full animate-ping" 
             style={{ animationDelay: '0.3s' }} />
        <div data-component-id="src/components/CopyNotification.tsx:63:8" data-component-path="src/components/CopyNotification.tsx" data-component-line="63" data-component-end-line="64" data-component-file="CopyNotification.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20-bottom-3%20left-2%20w-2.5%20h-2.5%20bg-primary%2F50%20rounded-full%20animate-ping%22%7D" className="absolute -bottom-3 left-2 w-2.5 h-2.5 bg-primary/50 rounded-full animate-ping" 
             style={{ animationDelay: '0.2s' }} />
      </div>
    </div>
  );
};

export default CopyNotification;
